import { render, staticRenderFns } from "./TestUser.vue?vue&type=template&id=0ea7144c&"
import script from "./TestUser.vue?vue&type=script&lang=js&"
export * from "./TestUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports